import { NgIf } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { RestrictionResult } from '@sc/data-access-models';
import { ButtonComponent } from '../button';
import { IconComponent } from '../icon';

@Component({
  selector: 'sc-restriction-warn-sheet',
  styleUrls: ['./restriction-warn-sheet.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgIf, IconComponent, ButtonComponent, TranslateModule],
  template: `
    <div class="restriction-warn-container">
      <button type="button" class="close-btn" (click)="onQuitSheet()">
        <sc-icon name="close"></sc-icon>
        <span class="sr_only">{{
          'GlobalApplicativeConstants.accessibility.closeDialog'
            | translate
              : {
                  dialogTitle:
                    'RestrictionDialog.' + restrictionInfos.name + '.title'
                    | translate
                }
        }}</span>
      </button>

      <div class="warn-icon">
        <sc-icon name="alert"></sc-icon>
      </div>

      <h1
        mat-dialog-title
        id="restriction-warn-title-id"
        class="sc-design-title-h2"
      >
        {{
          'RestrictionDialog.' + restrictionInfos.name + '.title' | translate
        }}
      </h1>

      <ng-container *ngIf="restrictionInfos.name === 'sameLicensePlate'">
        <div class="license-plate-container">
          <p class="license-plate-title-text sc-design-title-h3">
            {{
              'RestrictionDialog.' + restrictionInfos.name + '.plateDisplayed'
                | translate
            }}
          </p>
          <div class="license-plate-display">
            <p class="sc-design-text-4-bold">{{ licensePlate }}</p>
          </div>
        </div>

        <p
          class="nb-days-unavailable sc-design-text-4"
          [innerHTML]="
            'RestrictionDialog.' +
              restrictionInfos.name +
              '.restrictionDaysText'
              | translate
                : {
                    daysRestricted: getNbRestrictedDays()
                  }
          "
        ></p>
      </ng-container>

      <ng-container *ngIf="restrictionInfos.redirectUri">
        <sc-button (click)="onRedirectBtnClick()">{{
          'RestrictionDialog.' + restrictionInfos.name + '.redirectBtnText'
            | translate
        }}</sc-button>
      </ng-container>
    </div>
  `,
})
export class RestrictionWarnSheetComponent {
  @Input() restrictionInfos: RestrictionResult[0];
  @Input() licensePlate?: string;

  @Output() cancelEvent = new EventEmitter<void>();
  @Output() redirectEvent = new EventEmitter<string>();

  getNbRestrictedDays() {
    return Math.floor(this.restrictionInfos.minutes / (60 * 24));
  }

  onRedirectBtnClick() {
    this.redirectEvent.emit(this.restrictionInfos.redirectUri);
  }

  onQuitSheet() {
    this.cancelEvent.emit();
  }
}
